<div class="modal app-close-modal" id="appCloseModal" tabindex="-1" role="dialog"
    aria-labelledby="appCloseModalTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-left" id="appCloseModalTitle">{{'FOC.DESKTOP.CLOSE_DIALOG.HEADING' | translate}}</h5>
                <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" #closeModal>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="m-0">{{'FOC.DESKTOP.CLOSE_DIALOG.QUIT_MSG' | translate}}</p>
                <!-- <p *ngIf="downloadInProgress" class="mb-0 mt-2">{{'FOC.DESKTOP.CLOSE_DIALOG.DOWNLOAD_IN_PROGRESS' | translate}}</p> -->
            </div>
            <span class="close-label ml-3"data-dismiss="modal" aria-label="Close">
                {{'FOC.DESKTOP.CLOSE_DIALOG.NO' | translate}}</span>
            <div class="modal-footer d-flex flex-row justify-content-center">
                <button type="button" class="btn btn-purple" (click)="quitApp()">
                    <span>{{'FOC.DESKTOP.CLOSE_DIALOG.YES' | translate}}</span>
                    <span *ngIf="showAppCloseLoader" class="custom-loader ml-2">
                        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>